import { create } from "zustand";

export interface Filters {
	query?: string;
}

export type ViewMode = "row" | "medium" | "large";

export type SortDir = "asc" | "desc";

interface FiltersState {
	filters: Filters;
	view: ViewMode;
	sort: SortDir;
	setView: (view: ViewMode) => void;
	setSort: (sort: SortDir) => void;
	setFilters: (query: string) => void;
}

const useFiltersStore = create<FiltersState>((set) => ({
	filters: {
		query: "",
	},
	view: "large",
	sort: "desc",
	setView: (view) => set({ view }),
	setSort: (sort) => set({ sort }),
	setFilters: (query) => set({ filters: { query } }),
}));

export const useFilters = () => useFiltersStore((state) => state.filters);
export const useView = () => useFiltersStore((state) => state.view);
export const useSort = () => useFiltersStore((state) => state.sort);
export const useSetView = () => useFiltersStore((state) => state.setView);
export const useSetSort = () => useFiltersStore((state) => state.setSort);
export const useSetFilters = () => useFiltersStore((state) => state.setFilters);
